import {TextStyle, IPointData} from 'pixi.js';

export type VerticalAlign = 'bottom' | 'center' | 'top';
export type TextTransform = 'lowercase' | 'uppercase' | undefined;
export type TextStyleParams = Partial<TextStyle>;

export class RichTextTextStyle extends TextStyle {
    verticalAlign: VerticalAlign;
    textTransform: TextTransform;
    position?: IPointData;
    scale?: IPointData;

    constructor(options: Partial<RichTextTextStyle>) {
        super(options);

        this.verticalAlign = options.verticalAlign || 'top';
        this.textTransform = options.textTransform;
        this.position = options.position;
        this.scale = options.scale;
    }
}

export type RichTextStyleParams = Partial<RichTextTextStyle>;